<template>
  <v-row justify="center">
    <v-dialog v-model="theDialog" persistent value="" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ modalTitle }} Appointment</span>
          <v-spacer></v-spacer>
          <v-btn text icon color="grey" @click="onClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <confirm-delete-in-modal
              v-if="showConfirmDelete"
              @confirmed="onConfirmDelete"
            ></confirm-delete-in-modal>
            <v-form ref="form" v-model="valid">
              <ValidationObserver>
                <v-row>
                  <v-col class="py-1" cols="12" sm="12">
                    <v-autocomplete
                      :required="requiredAppointmentFields.includes('customer')"
                      :rules="
                        requiredAppointmentFields.includes('customer')
                          ? [rules.required]
                          : []
                      "
                      v-model="customerValue"
                      autocomplete="off"
                      :search-input.sync="customerSearchTerm"
                      no-filter
                      :items="customersList"
                      item-text="name"
                      item-value="id"
                      name="customernam"
                      label="Customer"
                      @change="onChangeCustomer"
                      dense
                      :no-data-text="noDataText.customer"
                      :append-outer-icon="
                        customerValue ? 'mdi-open-in-new' : null
                      "
                      @click:append-outer="onOpenCustomer"
                      autofocus
                      outlined
                    ></v-autocomplete>
                  </v-col>
                  <v-col class="py-1" cols="12" sm="12">
                    <v-autocomplete
                      :required="requiredAppointmentFields.includes('address')"
                      :rules="
                        requiredAppointmentFields.includes('address')
                          ? [rules.required]
                          : []
                      "
                      v-model="addressValue"
                      :items="addressList"
                      item-text="fullAddress"
                      item-value="id"
                      ref="address_field"
                      name="customeradd"
                      label="Address"
                      @change="onChangeAddress"
                      dense
                      :disabled="!customerValue"
                      autocomplete="off"
                      :no-data-text="noDataText.address"
                      outlined
                    ></v-autocomplete>
                  </v-col>
                  <v-col class="py-1" cols="12" sm="12">
                    <v-autocomplete
                      :required="
                        requiredAppointmentFields.includes('contactInfo')
                      "
                      :rules="
                        requiredAppointmentFields.includes('contactInfo')
                          ? [rules.required]
                          : []
                      "
                      v-model="contactInfoValue"
                      :items="contactInfoList"
                      item-text="detail"
                      item-value="id"
                      ref="contact_info_field"
                      name="customercon"
                      label="Contact Info"
                      @change="onChangeContactInfo"
                      dense
                      :disabled="!customerValue"
                      autocomplete="off"
                      :no-data-text="noDataText.contactInfo"
                      outlined
                    ></v-autocomplete>
                  </v-col>
                  <v-col class="py-1" cols="12" sm="12">
                    <v-autocomplete
                      :required="
                        requiredAppointmentFields.includes('serviceEmployee')
                      "
                      :rules="
                        requiredAppointmentFields.includes('serviceEmployee')
                          ? [rules.required]
                          : []
                      "
                      v-model="serviceEmployeeValue"
                      :items="serviceEmployeeList"
                      item-text="longName"
                      item-value="id"
                      name="customerser"
                      label="Service Employee"
                      dense
                      autocomplete="off"
                      :no-data-text="noDataText.serviceEmployee"
                      outlined
                    ></v-autocomplete>
                  </v-col>
                  <v-col class="py-1" cols="12" sm="12">
                    <v-autocomplete
                      :required="requiredAppointmentFields.includes('jobType')"
                      :rules="
                        requiredAppointmentFields.includes('jobType')
                          ? [rules.required]
                          : []
                      "
                      v-model="jobTypeValue"
                      :items="jobTypeList"
                      item-text="name"
                      item-value="id"
                      name="customerjob"
                      label="Job Type"
                      dense
                      autocomplete="off"
                      :no-data-text="noDataText.jobType"
                      outlined
                    ></v-autocomplete>
                  </v-col>

                  <v-col class="py-1" cols="12" sm="6">
                    <v-menu
                      v-model="startMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <ValidationProvider
                          name="start"
                          rules="required|endAfterStart:@start,@end"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="formattedStartDateTimeValue"
                            :error-messages="errors"
                            label="Start"
                            :append-icon="'mdi-calendar'"
                            readonly
                            v-on="on"
                            dense
                            outlined
                          ></v-text-field>
                        </ValidationProvider>
                      </template>
                      <v-datetime-picker
                        v-model="startDateTimeValue"
                        @input="startMenu = false"
                        :text-field-props="dtpTextFieldProps"
                        :date-picker-props="dtpDateProps"
                        :time-picker-props="dtpTimeProps"
                        time-format="HH:mm"
                      ></v-datetime-picker>
                    </v-menu>
                  </v-col>

                  <v-col class="py-1" cols="12" sm="6">
                    <v-menu
                      v-model="endMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <ValidationProvider
                          name="end"
                          rules="required|endAfterStart:@start,@end"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="formattedEndDateTimeValue"
                            :error-messages="errors"
                            label="End"
                            :append-icon="'mdi-calendar'"
                            readonly
                            v-on="on"
                            dense
                            outlined
                          ></v-text-field>
                        </ValidationProvider>
                      </template>
                      <v-datetime-picker
                        v-model="endDateTimeValue"
                        @input="endMenu = false"
                        :text-field-props="dtpTextFieldProps"
                        :date-picker-props="dtpDateProps"
                        :time-picker-props="dtpTimeProps"
                        time-format="HH:mm"
                      ></v-datetime-picker>
                    </v-menu>
                  </v-col>
                  <v-col class="py-1" cols="12">
                    <v-textarea
                      :required="requiredAppointmentFields.includes('note')"
                      :rules="
                        requiredAppointmentFields.includes('note')
                          ? [rules.required]
                          : []
                      "
                      v-model="noteValue"
                      label="Note"
                      rows="3"
                      dense
                      outlined
                    ></v-textarea>
                  </v-col>
                </v-row>
              </ValidationObserver>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="showDelete" color="blue darken-1" text @click="onDelete"
            >Delete</v-btn
          >
          <v-btn color="primary tile" @click="onSave"
            >&nbsp;&nbsp;&nbsp;Save&nbsp;&nbsp;&nbsp;</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { format, addMinutes, roundToNearestMinutes } from "date-fns";
const ConfirmDeleteInModal = () =>
  import(
    /* webpackChunkName: "components-customers-modals-ConfirmDeleteInModal" */ `./ConfirmDeleteInModal.vue`
  );
import Fuse from "fuse.js";
import {
  CUSTOMER_SEARCH_FUSE_OPTIONS,
  CALENDAR_APPOINTMENT_FIELDS
} from "../../../globalVars";

extend("endAfterStart", {
  params: ["start", "end"],
  validate(value, { start, end }) {
    if (start && end) {
      start = Date.parse(start);
      end = Date.parse(end);
      return start < end;
    } else {
      return true;
    }
  },
  message: "Can't end after it starts"
});
extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1
    };
  },
  computesRequired: true
});

export default {
  name: "AppointmentFormModal",
  $_veeValidate: {
    validator: "new"
  },
  props: {
    appointmentId: Number,
    appointmentCustomerId: Number,
    // appointmentAllDay: Boolean,
    appointmentStart: Date,
    appointmentEnd: Date
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    ConfirmDeleteInModal
  },
  data: () => ({
    theDialog: true,
    modalTitle: "Add",
    valid: true,
    showConfirmDelete: false,
    customerSearchTerm: null,
    customerValue: null,
    addressValue: null,
    contactInfoValue: null,
    serviceEmployeeValue: null,
    jobTypeValue: null,
    startDateTimeValue: roundToNearestMinutes(addMinutes(new Date(), 60), {
      nearestTo: 30
    }),
    endDateTimeValue: roundToNearestMinutes(addMinutes(new Date(), 90), {
      nearestTo: 30
    }),
    noteValue: null,
    startMenu: false,
    endMenu: false,
    dtpTextFieldProps: {
      appendIcon: "mdi-calendar"
    },
    dtpDateProps: {},
    dtpTimeProps: {
      ampmInTitle: true,
      allowedMinutes: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55]
    },
    noDataText: {
      customer: "No customers to choose from",
      address: "No addresses for this customer",
      contactInfo: "No contact info for this customer",
      serviceEmployee: "No service employees set up",
      jobTypes: "No job types set up"
    },
    rules: {
      required: value => !!value || "Required",
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid email";
      },
      phone: value => {
        return (
          (value && value.match(/\d/g) && value.match(/\d/g).length >= 10) ||
          "Invalid phone number"
        );
      },
      zip: value => {
        // eslint-disable-next-line no-useless-escape
        const pattern = /^(\d{5}(?:\-\d{4})?)$/;
        return pattern.test(value) || "Invalid ZIP";
      }
    }
  }),
  computed: {
    isAddNew() {
      return parseInt(this.appointmentId) == -1;
    },
    showDelete() {
      return !this.isAddNew && !this.showConfirmDelete;
    },
    currentAppointment() {
      let appointment = this.$store.getters["entities/appointments/find"](
        this.appointmentId
      );
      return appointment;
    },
    user() {
      return this.$store.getters["entities/users/find"](
        this.$store.getters["entities/settings/query"]().first().userId
      );
    },
    settings() {
      return this.$store.getters["entities/settings/query"]().first();
    },
    requiredAppointmentFields() {
      if (
        this.settings &&
        this.settings.calendarSettings &&
        this.settings.calendarSettings.requiredAppointmentFields
      ) {
        return this.settings.calendarSettings.requiredAppointmentFields;
      }
      return CALENDAR_APPOINTMENT_FIELDS.map(obj => obj.value);
    },
    customerLookup() {
      return this.$store.getters["entities/customerLookups/query"]()
        .orderBy("date", "desc")
        .get();
    },
    customersList() {
      let newList;
      if (!this.customerSearchTerm && this.customerValue) {
        newList = this.customerLookup;
      } else if (!this.customerSearchTerm) {
        newList = this.customerLookup.slice(0, 100);
      } else {
        let fuse = new Fuse(this.customerLookup, CUSTOMER_SEARCH_FUSE_OPTIONS);
        newList = fuse.search(this.customerSearchTerm).slice(0, 100);
      }
      newList.push({
        id: "new",
        name: "- Add New Customer -"
      });
      return newList;
    },
    addressList() {
      let addressList = this.$store.getters["entities/addresses/query"]()
        .where("customerId", this.customerValue)
        .get();
      addressList.push({
        id: "new",
        fullAddress: "- Add New Address -"
      });
      return addressList;
    },
    contactInfoList() {
      let contactInfoList = this.$store.getters[
        "entities/contactInfos/query"
      ]()
        .where("customerId", this.customerValue)
        .get();
      contactInfoList.push({
        id: "new",
        detail: "- Add Contact Info -"
      });
      return contactInfoList;
    },
    serviceEmployeeList() {
      return this.$store.getters["entities/users/query"]()
        .orderBy("longName")
        .get()
        .filter(user => {
          // Service Employees are id = 2
          return user.roles && user.roles.includes(2);
        });
    },
    jobTypeListId() {
      let listType = this.$store.getters["entities/listTypes/query"]()
        .where(type => {
          return type.code == "jobType";
        })
        .get();
      return listType.length > 0 ? listType[0].id : null;
    },
    jobTypeList() {
      let vueThis = this;
      let jobTypeList = this.$store.getters["entities/listItems/query"]()
        .where(item => {
          return item.listTypeId == vueThis.jobTypeListId;
        })
        .get();
      return jobTypeList.length > 0
        ? jobTypeList.sort(
            (a, b) => (a.rank ? a.rank : 0) - (b.rank ? b.rank : 0)
          )
        : [];
    },
    formattedStartDateTimeValue() {
      const formattedDate = format(this.startDateTimeValue, "M/d/yy h:mm aa");
      return formattedDate;
    },
    formattedEndDateTimeValue() {
      const formattedDate = format(this.endDateTimeValue, "M/d/yy h:mm aa");
      return formattedDate;
    }
  },
  created() {
    if (this.appointmentId > 0) {
      this.modalTitle = "Update";
      this.customerValue = this.currentAppointment.customerId;
      this.addressValue = this.currentAppointment.addressId;
      this.contactInfoValue = this.currentAppointment.contactInfoId;
      this.serviceEmployeeValue = this.currentAppointment.serviceEmployeeId;
      this.jobTypeValue = this.currentAppointment.jobTypeId;
      this.startDateTimeValue = new Date(this.currentAppointment.startTime);
      this.endDateTimeValue = new Date(this.currentAppointment.endTime);
      this.noteValue = this.currentAppointment.note;
      // TODO need to update all day logic
      // this.appointmentAllDay = false;
      if (this.currentAppointment && this.currentAppointment.customerId) {
        this.onChangeCustomer(this.currentAppointment.customerId);
      }
    } else {
      if (this.appointmentStart) {
        this.startDateTimeValue = this.appointmentStart;
        this.endDateTimeValue = this.appointmentEnd;
      }
      if (this.appointmentCustomerId > 0) {
        this.customerValue = this.appointmentCustomerId;
      }
    }
  },
  methods: {
    onClose() {
      this.$parent.showAppointmentFormModal = false;
      this.$parent.AppointmentModalId = -1;
      this.$parent.AppointmentModalCustomerId = null;
      this.$parent.AppointmentModalAllDay = false;
      this.$parent.AppointmentModalStart = null;
      this.$parent.AppointmentModalEnd = null;
      this.$root.$children[0].showCustomerEditorModals = false;
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (this.isAddNew) {
          const tempId = this.$uuidv4();
          this.$store.dispatch("entities/appointments/createAppointment", {
            id: tempId,
            tempId: tempId,
            isDirty: true,
            accountId: this.user.accountId,
            customerId: this.customerValue,
            jobTypeId: this.jobTypeValue,
            addressId: this.addressValue,
            contactInfoId: this.contactInfoValue,
            serviceEmployeeId: this.serviceEmployeeValue,
            note: this.noteValue,
            startTime:
              typeof this.startDateTimeValue == "number"
                ? new Date(this.startDateTimeValue)
                : this.startDateTimeValue,
            endTime:
              typeof this.endDateTimeValue == "number"
                ? new Date(this.endDateTimeValue)
                : this.endDateTimeValue
          });
        } else if (this.appointmentId > 0) {
          this.$store.dispatch("entities/appointments/updateAppointment", {
            accountId: this.user.accountId,
            customerId: this.customerValue,
            isDirty: true,
            id: this.appointmentId,
            jobTypeId: this.jobTypeValue,
            addressId: this.addressValue,
            contactInfoId: this.contactInfoValue,
            serviceEmployeeId: this.serviceEmployeeValue,
            note: this.noteValue,
            startTime:
              typeof this.startDateTimeValue == "number"
                ? new Date(this.startDateTimeValue)
                : this.startDateTimeValue,
            endTime:
              typeof this.endDateTimeValue == "number"
                ? new Date(this.endDateTimeValue)
                : this.endDateTimeValue
          });
        }
        this.onClose();
      }
    },
    onDelete() {
      this.showConfirmDelete = true;
    },
    onConfirmDelete() {
      this.$store.dispatch("entities/appointments/deleteAppointment", {
        accountId: this.user.accountId,
        id: this.appointmentId,
        isDirty: true
      });
      this.onClose();
    },
    onSetStartDate(newDate) {
      this.startDateTimeValue = newDate;
    },
    onSetEndDate(newDate) {
      this.endDateTimeValue = newDate;
    },
    onChangeCustomer(id) {
      this.$store.dispatch("entities/customers/fetchCustomerDataJoins", {
        joins: "addresses+contactInfos",
        customerId: id,
        startFresh: true
      });
    },
    onOpenCustomer(id) {
      if (id && this.customerValue) {
        this.$root.$children[0].showCustomerEditorModals = false;
        this.$parent.showAppointmentFormModal = false;
        this.$store.dispatch("entities/users/update", {
          where: this.user.id,
          data: { currentCustomerId: this.customerValue }
        });
        this.$router.push({ name: "customers" });
      }
    },
    onChangeContactInfo(id) {
      if (id == "new") {
        this.contactInfoValue = null;
      }
      if (id == "new" && this.customerValue) {
        this.$root.$children[0].showCustomerEditorModals = true;
        let theContainer = this.$root.$children[0].$refs[
          "customer-editor-modals"
        ];
        theContainer.ContactInfoModalId = -1;
        theContainer.CustomerId = this.customerValue;
        theContainer.showContactInfoFormModal = true;
      }
    },
    onChangeAddress(id) {
      if (id == "new") {
        this.addressValue = null;
      }
      if (id == "new" && this.customerValue) {
        this.$root.$children[0].showCustomerEditorModals = true;
        let theContainer = this.$root.$children[0].$refs[
          "customer-editor-modals"
        ];
        theContainer.AddressModalId = -1;
        theContainer.CustomerId = this.customerValue;
        theContainer.showAddressFormModal = true;
      }
    }
  },
  watch: {
    addressList: function(newVal, oldVal) {
      if (
        (newVal.length > 0 && oldVal.length == 0) ||
        (newVal.length > 0 && oldVal.length > 0 && newVal[0].id != oldVal[0].id)
      ) {
        if (!this.currentAppointment) {
          let addresses = newVal.filter(function(obj) {
            return obj.type == "main";
          });
          this.addressValue =
            addresses && addresses.length > 0 ? addresses[0].id : newVal[0].id;
        }
      } else if (
        newVal.length > 0 &&
        oldVal.length > 0 &&
        newVal.length > oldVal.length
      ) {
        let addresses = newVal.filter(function(obj) {
          return obj.type == "main";
        });
        this.addressValue =
          addresses && addresses.length > 0
            ? addresses[addresses.length - 1].id
            : newVal[newVal.length - 1].id;
      }
    },
    contactInfoList: function(newVal, oldVal) {
      if (
        (newVal.length > 0 && oldVal.length == 0) ||
        (newVal.length > 0 && oldVal.length > 0 && newVal[0].id != oldVal[0].id)
      ) {
        if (!this.currentAppointment) {
          let contactInfos = newVal.filter(function(obj) {
            return obj.label == "mobile";
          });
          this.contactInfoValue =
            contactInfos && contactInfos.length > 0
              ? contactInfos[0].id
              : newVal[0].id;
        }
      } else if (
        newVal.length > 0 &&
        oldVal.length > 0 &&
        newVal.length > oldVal.length
      ) {
        let contactInfos = newVal.filter(function(obj) {
          return obj.label == "mobile";
        });
        this.contactInfoValue =
          contactInfos && contactInfos.length > 0
            ? contactInfos[contactInfos.length - 1].id
            : newVal[newVal.length - 1].id;
        let test = 0;
      }
    }
  }
};
</script>

<style scoped lang="stylus"></style>
